import SpriteSymbol from "../../../../node_modules/.store/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/.store/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-rightArrow",
  "use": "icon-rightArrow-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-rightArrow\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.00189 0.999999L8.04736 -6.95242e-07L15.6556 7.27735C16.0673 7.67116 16.0673 8.32884 15.6556 8.72265L8.04736 16L7.00189 15L14.3202 8L7.00189 0.999999Z\" fill=\"#9D9D9D\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol